export const preparePhone = (phone: string) => phone
  .trim()
  .split('(').join('')
  .split(')').join('')
  .split(' ').join('');